module.exports = __webpack_public_path__ + "static/niegolewskich_og-cf9df498e0ed819c4a1ab15181ffe625.jpg";